import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { inventoryBinLocationQueryLinkerSchema } from './inventory-bin-locations-query-linker-schema';

const inventoryBinLocationPivotType = z.enum(['primary', 'secondary']);
export type InventoryBinLocationPivotType = z.infer<typeof inventoryBinLocationPivotType>;

export const inventoryBinLocationQuerySchema = z.object({
  ...inventoryBinLocationQueryLinkerSchema.shape,
  pivot: z
    .object({
      bin_location_id: z.number().optional(),
      type: inventoryBinLocationPivotType,
    })
    .optional(),
});

export type InventoryBinLocationQuerySchema = z.infer<typeof inventoryBinLocationQuerySchema>;

export const inventoryBinLocationQueryAllSchema = paginatedResponseSchema(inventoryBinLocationQuerySchema);

export type InventoryBinLocationQueryAllSchema = z.infer<typeof inventoryBinLocationQueryAllSchema>;
